// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace TerminalApiStatus {
  export enum LicenseStatus {
    active = 'active',
    inactive = 'inactive',
    expired = 'expired',
  }

  export enum TerminalStatus {
    active = 'active',
    inactive = 'inactive',
  }

  export enum TerminalAuthorizationStatus {
    no_action_required = 'no_action_required',
    pending_activation = 'pending_activation',
    pending_renewal = 'pending_renewal',
    corrupted_reactivation_required = 'corrupted_reactivation_required',
  }
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ManagementApiStatus {
  export enum LicenseStatus {
    active = 'active',
    inactive = 'inactive',
    expired = 'expired',
    pending_renewal = 'pending_renewal',
    scheduled = 'scheduled',
  }
}
